import React from 'react';

// Styled Components
import {
  ModalOverlay,
  ModalContainer,
  ModalHeader,
  ModalTitle,
  ModalCloseButton,
  ModalBody,
  ModalDescription,
  ModalWarning,
  ModalActions,
  ConfirmButton,
  CancelButton,
  ModalInfo,
  ModalImage,
  UserName,
} from './DeleteAccountModal.styled';

// Icons
import { Iconify } from '../../../../../Xmerald-UI';
import useUserContext from '../../../../../hooks/useUserContext';
import utils from '../../../../../utils/utils';
import numeral from 'numeral';

export default function DeleteAccountModal({ isOpen, onClose, onConfirm, userName }) {
  const userLoyalty = utils.getUserLoyalty();
  const { level, lastLevel, points = {} } = userLoyalty;
  const imageNextLevel = require(`../../../../../assets/img/levels/current/level-${level.id}.png`);

  if (!isOpen) return null;

  const amount = numeral((points.total_rake * level.reward) / 100).format('$0,000');

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContainer onClick={e => e.stopPropagation()}>
        <ModalHeader>
          <ModalTitle>Confirmar Eliminación de Cuenta</ModalTitle>
          <ModalCloseButton onClick={onClose}>
            <Iconify icon="eva:close-fill" />
          </ModalCloseButton>
        </ModalHeader>

        <ModalBody>
          <ModalImage src={imageNextLevel} alt={level.name} />

          <ModalDescription>
            ¿Estás seguro de que quieres eliminar tu cuenta, <UserName>{userName}</UserName>?
          </ModalDescription>

          <ModalInfo>
            <p>
              Actualmente tienes un nivel <strong>{level.name} </strong> y {points.total} puntos.
            </p>
            <p>
              Equivalientes a <span>{amount}</span> MXN en rembolso a fin de mes
            </p>
            <p className="warning">
              Al eliminar tu cuentra se perderás todos tus puntos y recompensas.
            </p>
          </ModalInfo>
        </ModalBody>

        <ModalActions>
          <CancelButton onClick={onClose}>Cancelar</CancelButton>
          <ConfirmButton onClick={onConfirm}>Sí, Eliminar Mi Cuenta</ConfirmButton>
        </ModalActions>
      </ModalContainer>
    </ModalOverlay>
  );
}
